export default __webpack_public_path__ + "static/media/background.1b8f1374.jpeg";